import React from 'react'
import ProdsNServsComp from '../../ProdsNServsComp'
import {PSObjOne } from './Data'
function Services() {
  return (
    <>
    <ProdsNServsComp {...PSObjOne} />
    </>
  )
}

export default Services